"use strict";
import React from 'react'
import { Icon } from 'semantic-ui-react'
import { toastr } from 'react-redux-toastr';
import convertIcon from './convert-Icon';

function openURL(e, url) {
    e.preventDefault()
    e.stopPropagation()
    let redirectUrl = url.indexOf('://') === -1 ? 'http://' + url : url;
    return window.open(redirectUrl, '_blank');
}

function copyToClipboard(e, url) {
    e.preventDefault()
    e.stopPropagation()
    navigator.clipboard.writeText(url)
    toastr.success('Message', 'Content URL is copied to clipboard')
}

function contentURL(url, iconType) {
    return url ?
        <span>
            <Icon
                name={convertIcon(iconType)}
                className="clr-blue contentURLLink f_14 cursor-pointer"
                onClick={e => openURL(e, url)}
            /> &nbsp;&nbsp;
            <span
                onClick={e => copyToClipboard(e, url)}
                className="clr-blue cursor-pointer contentURLLink">
                Copy Link
            </span>
        </span > : null;
};

export default contentURL;